<template>
  <div class="content">
    <div id="mainGameboard" class="content">
      <div id="gameboardsvg" v-html="svg"/>
      <div id="dataAnalysis">
        <b-form-group label="Select Overlay:" v-if="analyzedCaselets.length > 0 && (role === 'Data Scientist' || role === 'unassigned')">
          <b-form-radio v-for="(caselet, index) in analyzedCaselets" :key="index" v-model="overlaySelect" :value="caselet">
            {{ caselet }}
          </b-form-radio>
          <b-button @click="clearOverlay()">Clear Overlay</b-button>
        </b-form-group>
      </div>
      <!--div id="caseletInfo"></div-->
      <div id="caseletMarkers"></div>
    </div>
    <div id="gameInfo">
      <div id="scores">
        <u><b>Day:</b></u> {{ day }}
        <b-button @click="nextRound">Advance Day</b-button>
        <b-button @click="reset">Reset</b-button>
        <h3>Resilience Indicators</h3>
        <p v-for="(score, index) in scores" :key="index">{{ index }}: {{ score }}</p>
      </div>
      <div id="assets">
        <h1>{{ role }} Assets<i class="fa fa-info-circle" id="info" v-b-modal.roles /></h1>
        <table>
          <thead>
            <tr>
              <th span="1" style="width: 30%;">Token</th>
              <th span="1" style="width: 50%;">Name</th>
              <th span="1" style="width: 20%;">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr class="asset" v-for="(asset, index) in tokens" :key="index" v-if="controls(asset.code)">
              <td span="1" style="width: 30%;"><img class="assetToken" :src="`${baseURL}storage/media/gameboard/tokens/${asset.type}Token.svg`" /></td>
              <td span="1" style="width: 50%;">{{ asset.name }}</td>
              <td span="1" style="width: 20%;">{{ asset.actions.available }}/{{ asset.actions.total }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div id="notifications">
      <Notifications
        :notifications="caselets"
        :forecast="forecast"
        :caseletList="caseletList"
        @resolve="resolveCaselet"
        @highlightTile="highlightTile"
        @analyze="analyze"
        @pushNotification="notify"
      />
      <!-- @notify="revealCaseletToken" -->
      <div id="chat">
        <Chat />
      </div>
    </div>
    <!-- Modal -->
    <b-modal id="move-error" title="System Message" ok-only hide-footer>
      {{ text }}
    </b-modal>

    <b-modal id="roles" title="Role Hierarchy" ok-only>
      <span v-for="(role, index) in roles" :key="index">
        <h3>{{ index }} controls:</h3>
        <span v-for="(code, cIndex) in role.controls" :key="cIndex">
          <ul>
            <span v-for="(token, tIndex) in tokens" :key="tIndex">
              <li v-if="token.code === code">
                {{ token.name }} ({{ code }}) - <img class="modalToken" :src="`${baseURL}/storage/media/gameboard/tokens/${token.type}Token.svg`" />
              </li>
            </span>
          </ul>
        </span>
      </span>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions, mapState, mapGetters } from 'vuex'
import Chat from '../chat/gameboardChat.vue'
import Notifications from './notification.vue'
// import './js/drag.js'

export default {
  layout: 'basepcs',

  metaInfo() {
    return { title: 'Gameboard' }
  },

  components: {
    Chat,
    Notifications,
  },

  data: () => ({
    dragging: false,
    showModal: false,
    text: null,
    selectedToken: null,
    start: null,
    offset: {
      x: null,
      y: null,
    },
    forecast: {
      "1A": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "2A": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "3A": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Medium"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Medium"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Medium"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "4A": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "5A": [
        {"name":"Fire","percentage":"Medium"},
        {"name":"Medical","percentage":"Medium"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Medium"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Medium"}
      ],
      "6A": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "7A": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "8A": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "9A": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Medium"},
        {"name":"Infrastructure Damage","percentage":"Medium"}
      ],
      "10A": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Medium"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "11A": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Medium"}
      ],
      "12A": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "13A": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "1B": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "2B": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "3B": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"High"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"High"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"High"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"High"}
      ],
      "4B": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "5B": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Medium"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Medium"}
      ],
      "6B": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "7B": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Medium"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "8B": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Medium"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Medium"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"High"}
      ],
      "9B": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Medium"},
        {"name":"Evacuation","percentage":"High"},
        {"name":"Infrastructure Damage","percentage":"High"}
      ],
      "10B": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"High"},
        {"name":"Infrastructure Damage","percentage":"High"}
      ],
      "11B": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "12B": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "13B": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "1C": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "2C": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "3C": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Medium"},
        {"name":"Food Insecurity","percentage":"Medium"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Medium"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Medium"}
      ],
      "4C": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Medium"}
      ],
      "5C": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Medium"},
        {"name":"Public Safety","percentage":"Medium"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Medium"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Medium"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "6C": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Medium"}
      ],
      "7C": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Medium"},
        {"name":"Toxic Cleanup","percentage":"Medium"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"High"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Medium"}
      ],
      "8C": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Medium"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Medium"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"High"}
      ],
      "9C": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"High"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"High"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Medium"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"High"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "10C": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Medium"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Medium"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"High"},
        {"name":"Infrastructure Damage","percentage":"High"}
      ],
      "11C": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "12C": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "13C": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "1D": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "2D": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "3D": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Medium"}
      ],
      "4D": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Medium"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Medium"}
      ],
      "5D": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Medium"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Medium"}
      ],
      "6D": [
        {"name":"Fire","percentage":"Medium"},
        {"name":"Medical","percentage":"Medium"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Medium"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Medium"},
        {"name":"Animal","percentage":"Medium"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "7D": [
        {"name":"Fire","percentage":"High"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"High"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "8D": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"High"},
        {"name":"Domestic Disturbance","percentage":"Medium"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Medium"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "9D": [
        {"name":"Fire","percentage":"High"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Medium"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Medium"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "10D": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Medium"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Medium"}
      ],
      "11D": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "12D": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "13D": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "1E": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "2E": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "3E": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "4E": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "5E": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "6E": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "7E": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "8E": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "9E": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "10E": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "11E": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"High"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "12E": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "13E": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "1F": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"High"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Medium"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "2F": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "3F": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Medium"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Medium"}
      ],
      "4F": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"High"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Medium"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Medium"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "5F": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "6F": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "7F": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Medium"}
      ],
      "8F": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"High"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "9F": [
        {"name":"Fire","percentage":"High"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "10F": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "11F": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Medium"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "12F": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Medium"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "13F": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "1G": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"High"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "2G": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Medium"}
      ],
      "3G": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "4G": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"High"}
      ],
      "5G": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Medium"}
      ],
      "6G": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Medium"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "7G": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Medium"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "8G": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "9G": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "10G": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "11G": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "12G": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"High"}
      ],
      "13G": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "1H": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "2H": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "3H": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "4H": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "5H": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "6H": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "7H": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "8H": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "9H": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "10H": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "11H": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "12H": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "13H": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "1I": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "2I": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "3I": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "4I": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "5I": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "6I": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "7I": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "8I": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "9I": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "10I": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "11I": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "12I": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "13I": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "1J": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "2J": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "3J": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "4J": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Medium"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "5J": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "6J": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "7J": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"High"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"High"}
      ],
      "8J": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "9J": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "10J": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "11J": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "12J": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "13J": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "1K": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "2K": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"High"}
      ],
      "3K": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "4K": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Medium"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Medium"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Medium"},
        {"name":"Evacuation","percentage":"High"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "5K": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "6K": [
        {"name":"Fire","percentage":"Medium"},
        {"name":"Medical","percentage":"Medium"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Medium"},
        {"name":"Toxic Cleanup","percentage":"Medium"},
        {"name":"Domestic Disturbance","percentage":"Medium"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"High"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "7K": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "8K": [
        {"name":"Fire","percentage":"Medium"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Medium"},
        {"name":"Public Safety","percentage":"High"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "9K": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Medium"}
      ],
      "10K": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "11K": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "12K": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "13K": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"High"},
        {"name":"Infrastructure Damage","percentage":"Medium"}
      ],
      "1L": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Medium"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Medium"},
        {"name":"Infrastructure Damage","percentage":"High"}
      ],
      "2L": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Medium"}
      ],
      "3L": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Medium"}
      ],
      "4L": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Medium"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "5L": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"High"},
        {"name":"Food Insecurity","percentage":"High"},
        {"name":"Public Safety","percentage":"High"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "6L": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Medium"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"High"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "7L": [
        {"name":"Fire","percentage":"Medium"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Medium"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Medium"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "8L": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"High"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "9L": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Medium"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "10L": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Medium"},
        {"name":"Toxic Cleanup","percentage":"High"},
        {"name":"Domestic Disturbance","percentage":"Medium"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "11L": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "12L": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "13L": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Medium"}
      ],
      "1M": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "2M": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "3M": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"High"}
      ],
      "4M": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"High"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"High"},
        {"name":"Animal","percentage":"High"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "5M": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "6M": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "7M": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "8M": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"High"},
        {"name":"Food Insecurity","percentage":"Medium"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "9M": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "10M": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "11M": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"High"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"High"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "12M": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "13M": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "1N": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "2N": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "3N": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "4N": [
        {"name":"Fire","percentage":"Medium"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Medium"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "5N": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "6N": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"High"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Medium"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "7N": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "8N": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "9N": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Medium"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "10N": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "11N": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "12N": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "13N": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "1O": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"High"}
      ],
      "2O": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Medium"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "3O": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "4O": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "5O": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"High"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Medium"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Medium"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "6O": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Medium"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "7O": [
        {"name":"Fire","percentage":"Medium"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Medium"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Medium"}
      ],
      "8O": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "9O": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "10O": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "11O": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "12O": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "13O": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "1P": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "2P": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "3P": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "4P": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "5P": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "6P": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "7P": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "8P": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "9P": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "10P": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "11P": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "12P": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "13P": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "1Q": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "2Q": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "3Q": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "4Q": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "5Q": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "6Q": [
        {"name":"Fire","percentage":"Medium"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "7Q": [
        {"name":"Fire","percentage":"High"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "8Q": [
        {"name":"Fire","percentage":"Medium"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"High"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "9Q": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "10Q": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"High"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "11Q": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "12Q": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Medium"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ],
      "13Q": [
        {"name":"Fire","percentage":"Low"},
        {"name":"Medical","percentage":"Low"},
        {"name":"Food Insecurity","percentage":"Low"},
        {"name":"Public Safety","percentage":"Low"},
        {"name":"Toxic Cleanup","percentage":"Low"},
        {"name":"Domestic Disturbance","percentage":"Low"},
        {"name":"Animal","percentage":"Low"},
        {"name":"Civil Unrest","percentage":"Low"},
        {"name":"Evacuation","percentage":"Low"},
        {"name":"Infrastructure Damage","percentage":"Low"}
      ]
    },
    showCaseletInfo: false,
    overlaySelect: null,
  }),

  computed: {
    ...mapState({
      user: state => state.auth.user,
      role: state => state.group.role.name,
      rules: state => state.gameboard.rules,
      day: state => state.gameboard.day,
      scores: state => state.gameboard.scores,
      svg: state => state.gameboard.svg,
      caseletBank: state => state.gameboard.caseletBank.bank,
      caselets: state => state.gameboard.caseletBank.active,
      tokenSvg: state => state.gameboard.tokenSvg.players,
      caseletSvg: state => state.gameboard.tokenSvg.caselets,
      tokens: state => state.gameboard.tokens.players,
      roles: state => state.gameboard.roleHierarchy,
      matrix: state => state.gameboard.moveMatrix,
      analyzedCaselets: state => state.gameboard.analyzed,
      caseletList: state => state.gameboard.rules.caselets,
      markers: state => state.gameboard.markers,
      refs: function() {
        return this.selectedToken.getAttribute('ref').split(' ')
      },
    }),
    ...mapGetters({
      classId: 'auth/classId'
    }),
    baseURL: function () {
      return process.env.MIX_BASE_URL
    },
  },

  created() {
    this.checkSVGloaded()
    // document.querySelector('.gameboard').getSVGDocument().getElementById('V16.1_BronzeFalls_Map').setAttribute('fill', 'red')
  },

  methods: {
    ...mapActions({
      updateState: 'gameboard/updateState',
      saveGameboard: 'gameboard/saveState',
    }),
    /* *************************************   Initial Load Functions   ************************************* */
    // Check to make sure the SVG is loaded on the page. Necessary because of teh size of the SVG.
    checkSVGloaded() {
      if (document.querySelector('#gameboard') == null) {
        setTimeout(this.checkSVGloaded, 300)
      } else {
        this.createPlayerTokens()
      }
    },

    createPlayerTokens() {
      let grid = document.getElementById('grid-layer').children
      let center = null
      let tiles = []
      this.tokens.forEach(token => {
        if (token.type !== 'analysis') {
          grid.forEach(square => {
            if (token.location === square.id) {
              center = square.getBBox()
            }
          })
          let x = center.x + ((center.width - token.width) / 2)
          let y = center.y + ((center.height - token.height) / 2)
          let html = '<svg class="token" id="' + token.id + '" ref="' + token.type + ' ' + token.code + '" width="' + token.width + '" height="' + token.height + '" x="' + x.toString() + '" y="' + y.toString() + '">' +
            this.tokenSvg[token.type] + '</svg>'
          document.getElementById('Tokens').innerHTML += html
          let found = false
          tiles.forEach(tile => {
            if (tile === token.location) {
              found = true
            }
          })
          if (!found) {
            tiles.push(token.location)
          }
        }
      })
      tiles.forEach(tile => {
        this.checkTileOccupants(tile, false)
      })
      this.SVGsetup()
    },

    // Setup the SVG with the appropiate classes and function calls
    SVGsetup() {
      this.caseletList.forEach(category => {
        category.analyzed = false
      })
      this.caseletMarkers()
      let tokens = document.getElementsByClassName('token')
      tokens.forEach(token => {
        token.style.cursor = 'move'
        token.addEventListener('mouseover', this.tokenHover)
        token.addEventListener('mouseout', this.clearHighlights)
        token.addEventListener('mousedown', this.drag)
        token.addEventListener('mouseup', this.drop)
      })
      /* this.caselets.forEach(caselet => {
        this.createCaselet(caselet)
      }) */
      this.loadCaselets()
    },

    caseletMarkers() {
      let x = 4240
      let y = 350
      this.caseletList.forEach(caselet => {
        this.createMarker(caselet.type, x, y, 'Markers', caselet.name)
        y += 125
      })
      let tokens = document.getElementById('Markers')
      tokens.children.forEach(token => {
        token.style.cursor = 'move'
        token.addEventListener('mousedown', this.drag)
        token.addEventListener('mouseup', this.drop)
      })
      this.markers.forEach(marker => {
        this.createMarker(marker.type, marker.x, marker.y, 'Caselets')
      })
      this.eventListeners()
    },

    createMarker(type, x, y, id, name) {
      let svg = this.caseletSvg[type]
      let html = '<svg class="marker" id="' + type + '_' + x + '_' + y + '" ref="' + type + ' marker" x="' + x.toString() + '" y="' + y.toString() + '">'
      if (name) {
        html += '<title>' + name + '</title>'
      }
      html += svg + '</svg>'
      document.getElementById(id).innerHTML += html
    },

    placeMarker() {
      let x = this.selectedToken.getAttribute('x')
      let y = this.selectedToken.getAttribute('y')
      this.createMarker(this.refs[0], x, y, 'Caselets')
      this.$store.state.gameboard.markers.push({
        type: this.refs[0],
        x: x,
        y: y,
      })
      this.selectedToken.setAttributeNS(null, 'x', this.start.x)
      this.selectedToken.setAttributeNS(null, 'y', this.start.y)
      this.markerUpdate(this.refs[0], x, y, 'create')
    },

    removeMarker(event) {
      let id = event.target.parentNode.getAttribute('id')
      let info = id.split('_')
      for (let i = this.$store.state.gameboard.markers.length - 1; i >= 0; i--) {
        let marker = this.$store.state.gameboard.markers[i]
        let check = marker.type + '_' + marker.x + '_' + marker.y
        if (check === id) {
          this.$store.state.gameboard.markers.splice(i, 1)
        }
      }
      this.markerUpdate(info[0], info[1], info[2], 'remove')
      event.target.parentNode.remove()
    },

    eventListeners() {
      document.getElementById('Caselets').children.forEach(marker => {
        marker.addEventListener('mousedown', this.removeMarker)
      })
    },

    markerUpdate(type, x, y, action) {
      axios.post('/api/gameboard/updateMarker', {
        params: {
          pcs: localStorage.getItem('pcs'),
          id: this.user.id,
          type: type,
          x: x,
          y: y,
          action: action,
        },
      }).then(response => {
        this.saveGameboard()
      })
    },

    reset() {
      axios.post('/api/gameboard/reset', {
        params: {
          group: this.$store.state.group.group.id,
          pcs: localStorage.getItem('pcs'),
        },
      }).then(response => {
        window.location.reload(false)
      })
    },

    /* *************************************   Player Token Functions   ************************************* */
    controls(code) {
      if (this.role === 'unassigned') {
        return true
      } else {
        return this.roles[this.role].controls.includes(code)
      }
    },

    // On mouse down of the movable tokens
    drag(event) {
      let refs = event.target.parentNode.getAttribute('ref').split(' ')
      let control = false
      if (refs[1] === 'marker') {
        this.selectedToken = event.target.parentNode
        control = true
        this.start = {
          x: event.target.parentNode.getAttribute('x'),
          y: event.target.parentNode.getAttribute('y'),
        }
      } else {
        if (this.role !== 'unassigned') {
          this.roles[this.role].controls.forEach(token => {
            if (token === this.refs[1]) {
              control = true
            }
          })
        }
      }
      if (control || this.role === 'unassigned') {
        this.offset = this.getMousePosition(event)
        this.offset.x -= parseFloat(this.selectedToken.getAttributeNS(null, 'x'))
        this.offset.y -= parseFloat(this.selectedToken.getAttributeNS(null, 'y'))
        document.getElementById('gameboard').addEventListener('mousemove', this.move)
        this.dragging = true
      }
    },

    // On mouse move for click and drag of moveable tokens
    move(event) {
      if (this.selectedToken) {
        event.preventDefault()
        let coord = this.getMousePosition(event)
        this.selectedToken.setAttributeNS(null, 'x', coord.x - this.offset.x)
        this.selectedToken.setAttributeNS(null, 'y', coord.y - this.offset.y)
      }
    },

    // On release of click of moveable token
    drop() {
      // let refs = this.selectedToken.getAttribute('ref').split(' ')
      if (this.dragging) {
        this.dragging = false
        document.getElementById('gameboard').removeEventListener('mousemove', this.move)
        if (this.refs[1] === 'marker') {
          this.placeMarker()
        } else {
          this.tokenLocation(true)
        }
      }
    },

    // Hover over the token (movable pieces)
    tokenHover(event) {
      let refs = event.target.parentNode.getAttribute('ref').split(' ')
      // type is pos 0, code is pos 1
      let control = false
      if (this.role !== 'unassigned') {
        this.roles[this.role].controls.forEach(token => {
          if (token === refs[1]) {
            control = true
          }
        })
      }
      if (!this.dragging && (control || this.role === 'unassigned')) {
        this.selectedToken = event.target.parentNode
        this.tokenLocation(false)
      }
    },

    // Get the mouse position used for the on mouse move for dragging pieces
    getMousePosition(event) {
      let CTM = document.getElementById('gameboard').getScreenCTM()
      return {
        x: (event.clientX - CTM.e) / CTM.a,
        y: (event.clientY - CTM.f) / CTM.d,
      }
    },

    // Gets the tile that the token is located in
    tokenLocation(moved) {
      let token = this.selectedToken
      let caseletX = token.x.baseVal.value
      let caseletY = token.y.baseVal.value
      token = token.getBBox()
      let tokenPos = {
        x: caseletX + (token.width / 2),
        y: caseletY + (token.height / 2),
      }
      let grid = document.getElementById('grid-layer').children
      grid.forEach(tile => {
        let temp = tile.getBBox()
        let gridTile = {
          left: temp.x,
          right: temp.x + temp.width,
          top: temp.y,
          bottom: temp.y + temp.height,
        }

        if (tokenPos.x < gridTile.right && tokenPos.x > gridTile.left && tokenPos.y > gridTile.top && tokenPos.y < gridTile.bottom) {
          if (moved) {
            this.checkMove(tile.id)
          } else {
            this.highlight(tile.id)
          }
        }
      })
    },

    // Highlights the possible moves from any given grid tile
    highlight(tile) {
      this.start = tile
      /* {
        x: this.selectedToken.x.baseVal.value,
        y: this.selectedToken.x.baseVal.value,
        tile: tile,
      } */
      let availableMoves = this.matrix[tile]
      availableMoves.forEach(move => {
        let grid = document.getElementById('grid-layer').children
        grid.forEach(tile => {
          if (move === tile.id) {
            document.getElementById(tile.id).setAttribute('fill', 'yellow')
            document.getElementById(tile.id).setAttribute('fill-opacity', '.5')
          }
        })
      })
    },

    // Unhighlights the possible moves
    clearHighlights() {
      if (!this.dragging) {
        let grid = document.getElementById('grid-layer').children
        grid.forEach(tile => {
          document.getElementById(tile.id).setAttribute('fill', 'none')
        })
        this.highlightOverlay()
      }
    },

    // centers the token on the tile it is being moved to or if it's an invalid move it moves it back to the starting tile
    centerToken(piece, tile) {
      let grid = document.getElementById('grid-layer').children
      let center = null
      grid.forEach(square => {
        if (tile === square.id) {
          center = square.getBBox()
        }
      })
      let token = piece.getBBox()
      let x = center.x + ((center.width - token.width) / 2)
      let y = center.y + ((center.height - token.height) / 2)
      piece.setAttributeNS(null, 'x', x.toString())
      piece.setAttributeNS(null, 'y', y.toString())
    },

    /* *************************************   Move Functions   ************************************* */
    // Checks to make sure that the move is valid according to the matrix
    checkMove(tile) {
      let valid = false
      this.matrix[this.start].forEach(move => {
        if (move === tile) {
          valid = true
        }
      })
      let move = false
      this.tokens.forEach(token => {
        if (token.id === this.selectedToken.id) {
          if (token.actions.available > 0) {
            move = true
          }
        }
      })
      if (valid && move) {
        this.showCaselets(tile)
        this.centerToken(this.selectedToken, tile)
        this.checkTileOccupants(tile, true)
      } else {
        if (!move && this.start !== tile) {
          this.modal('This asset doesn\'t have any moves left in this round')
        } else if (this.start !== tile) {
          this.modal('That isn\'t a valid move')
        }
        this.centerToken(this.selectedToken, this.start)
      }
    },

    // check if there are multiple tokens on one spot
    checkTileOccupants(tile, move) {
      let temp = document.getElementById(tile).getBBox()
      let bounds = {
        left: temp.x,
        right: temp.x + temp.width,
        top: temp.y,
        bottom: temp.y + temp.height,
        center: {
          x: temp.x + (temp.width / 2),
          y: temp.y + (temp.height / 2),
        },
      }
      let players = []
      document.getElementById('Tokens').children.forEach(token => {
        let player = token.getBBox()
        let playerPos = {
          id: token.id,
          width: player.width,
          height: player.height,
          centerX: token.x.baseVal.value + (player.width / 2),
          centerY: token.y.baseVal.value + (player.height / 2),
          x: token.x.baseVal.value,
          y: token.y.baseVal.value,
        }
        if (playerPos.centerX < bounds.right && playerPos.centerX > bounds.left && playerPos.centerY > bounds.top && playerPos.centerY < bounds.bottom) {
          players.push(playerPos)
        }
      })
      if (players.length === 1) {
        this.centerToken(document.getElementById(players[0].id), tile)
      } else if (players.length === 2) {
        document.getElementById(players[0].id).setAttribute('x', bounds.center.x - players[0].width)
        document.getElementById(players[1].id).setAttribute('x', bounds.center.x)
        document.getElementById(players[0].id).setAttribute('y', bounds.center.y - (players[0].width / 2))
        document.getElementById(players[1].id).setAttribute('y', bounds.center.y - (players[0].width / 2))
      } else if (players.length > 2) {
        let i = 0
        players.forEach(player => {
          // set x
          if (i === 0 || i === 2) {
            document.getElementById(player.id).setAttribute('x', bounds.center.x - player.width)
          } else {
            document.getElementById(player.id).setAttribute('x', bounds.center.x)
          }
          // set y
          if (i < 2) {
            document.getElementById(player.id).setAttribute('y', bounds.center.y - player.height)
          } else {
            document.getElementById(player.id).setAttribute('y', bounds.center.y)
          }
          i++
        })
      }
      if (move) {
        this.sendMove(tile)
        this.checkTileOccupants(this.start, false)
      }
    },

    // Sends a valid move to the backend
    sendMove(tile) {
      console.log('send Move')
      this.tokens.forEach(token => {
        if (token.id === this.selectedToken.id) {
          token.actions.available -= 1
        }
      })
      this.clearHighlights()
      this.$store.state.gameboard.tokens.players.forEach(token => {
        if (token.id === this.selectedToken.id) {
          token.location = tile
        }
      })
      axios.post('/api/piece/moved', {
        params: {
          start: this.start,
          end: tile,
          pcs: localStorage.getItem('pcs'),
          id: this.user.id,
          token: this.selectedToken.id,
          x: this.selectedToken.x.baseVal.value,
          y: this.selectedToken.y.baseVal.value,
          moves: 1,
        },
      }).then(response => {
        this.highlight(tile)
        this.saveGameboard()
      })
    },

    checkNextRound() {
      let nextRound = true
      this.tokens.forEach(token => {
        if (token.actions.available > 0) {
          nextRound = false
        }
      })
      if (nextRound) {
        this.nextRound()
      }
    },

    nextRound() {
      axios.post('/api/progress/day', {
        params: {
          pcs: localStorage.getItem('pcs'),
          id: this.user.id,
        },
      }).then(response => {
        this.loadCaselets()
      })
    },

    /* *************************************   Caselet Functions   ************************************* */
    loadCaselets() {
      // console.log('A', this.caseletBank, this.$store.state.gameboard.caseletBank.active)
      /* if (this.day > 1) {
        this.$store.state.gameboard.caseletBank.active.forEach(caselet => {
          if (caselet.hidden === true) {
            caselet.hidden = false
          }
        })
      } */

      if (typeof this.caseletBank[this.day - 1] !== 'undefined' && this.caseletBank[this.day - 1].length > 0) {
        this.caseletBank[this.day - 1].forEach(caselet => {
          // get location data
          try {
            let location = document.getElementById(caselet.location).getBBox()
            caselet.x = location.x
            caselet.y = location.y

            let grid = document.getElementById('grid-layer').children
            grid.forEach(tile => {
              let temp = tile.getBBox()
              let gridTile = {
                left: temp.x,
                right: temp.x + temp.width,
                top: temp.y,
                bottom: temp.y + temp.height,
              }

              if (location.x < gridTile.right && location.x > gridTile.left && location.y > gridTile.top && location.y < gridTile.bottom) {
                caselet.tile = tile.id
              }
            })
            /*if (!caselet.resolved) {
              this.createCaselet(caselet)
            }*/
            this.$store.state.gameboard.caseletBank.active.push(caselet)
          } catch (error) {
            console.log(caselet.location)
          }
        })
        this.$store.state.gameboard.caseletBank.bank[this.day - 1] = []
        setTimeout(() => {
          this.dispatchCaselets()
          this.saveGameboard()
        }, 1000)
      }
    },

    dispatchCaselets() {
      for (let i = 0; i < 2; i++) {
        let dispatch = false
        while (!dispatch) {
          let csl = this.caselets[Math.floor(Math.random() * this.caselets.length)]
          if (csl.hidden.length === 0) {
            csl.dispatch = true
            dispatch = true
          }
        }
      }
      let dispatch = []
      let unread = 0
      this.caselets.forEach(caselet => {
        caselet.dispatchMessage = caselet.tile + ': ' + caselet.detail
        if (caselet.dispatch && !caselet.dispatchSent) {
          unread += 1
          let csl = ['911', caselet.dispatchMessage, -911, new Date()]
          dispatch.unshift(csl)
          axios.post('/api/message', {
            params: {
              message: caselet.dispatchMessage,
              pcs: localStorage.getItem('pcs'),
              classId: this.classId,
              recipient: '911',
              recipientid: -911,
              name: '911',
              id: -911,
              timestamp: new Date(),
              all: true,
              group: this.$store.state.group.group.id,
            },
          }).then(response => {
            caselet.dispatchSent = true
          })
        }
      })

      let offline = []
      let convos = this.$store.state.chat.conversations
      setTimeout(function() {
        convos.forEach((convo, index) => {
          // check if the other user is on
          if (convo.id >= 0 && !convo.online) {
            offline.push(convo)
          }
        })

        offline.forEach(user => {
          setTimeout(() => {
            axios.post('/api/dispatchMsgOffline', {
              params: {
                messages: dispatch,
                pcs: localStorage.getItem('pcs'),
                sender: '911',
                senderid: -911,
                recipient: user.name,
                recipientid: user.id,
                general: -911,
                unread: unread,
              },
            })
          }, 1000)
        })
      }, 1000)
    },

    /* createCaselet(caselet) {
      let visible = 'hidden'
      if (caselet.notified) {
        visible = 'visible'
      }
      let html = '<svg ref="' + caselet.type + '" id="' + caselet.id + '" x="' + caselet.x + '" y="' + caselet.y +
        '" visibility="' + visible + '">' +
        this.caseletSvg[caselet.type] + '</svg>'
      document.getElementById('Caselets').innerHTML += html
      let token = document.getElementById(caselet.id)
      let temp = token.getBBox()
      token.setAttribute('x', token.x.baseVal.value - (temp.width / 2))
      token.setAttribute('y', token.y.baseVal.value - (temp.height / 2))
      if (caselet.notified) {
        token.addEventListener('mouseover', this.caseletInfo)
        token.addEventListener('mouseout', this.hideCaseletInfo)
        token.addEventListener('mousedown', this.resolveCaselet)
      }
      if (caselet.type === 'infrastructure') {
        // console.log(caselet, html)
        // this.showCaseletToken(caselet.id)
      }
    }, */

    showCaselets(tile) {
      let temp = document.getElementById(tile).getBBox()
      let bounds = {
        x: temp.x,
        y: temp.y,
        width: temp.width,
        height: temp.height,
        left: temp.x - temp.width,
        right: temp.x + temp.width + temp.width,
        top: temp.y - temp.height,
        bottom: temp.y + temp.height + temp.height,
      }
      this.caselets.forEach(caselet => {
        let position = {
          x: caselet.x,
          y: caselet.y,
        }
        if (
          ((position.x < bounds.right && position.x > bounds.left && position.y > bounds.y && position.y < bounds.y + bounds.height) ||
            (position.x < bounds.x + bounds.width && position.x > bounds.x && position.y > bounds.top && position.y < bounds.bottom)) &&
          caselet.resolved === false
        ) {
          this.showCaseletToken(caselet.id)
        }
      })
      this.saveGameboard()
    },

    showCaseletToken(id) {
      this.caselets.forEach(caselet => {
        if (caselet.id === id) {
          caselet.hidden.push(this.user.id)
        }
      })
    },

    /* revealCaseletToken(index) {
      this.caselets[index].notified = true
      let id = this.caselets[index].id
      document.getElementById(id).addEventListener('mouseover', this.caseletInfo)
      document.getElementById(id).addEventListener('mouseout', this.hideCaseletInfo)
      document.getElementById(id).addEventListener('mousedown', this.resolveCaselet)
      document.getElementById(this.caselets[index].id).setAttribute('visibility', 'visible')
      axios.post('/api/caselet/updated', {
        params: {
          pcs: localStorage.getItem('pcs'),
          id: this.user.id,
          token: this.caselets[index].id,
          caselet: this.caselets[index],
        },
      })
      this.saveGameboard()
    }, */

    resolveCaselet(index) {
      console.log(this.caselets[index])
      let caselet = this.caselets[index]
      let players = []
      document.getElementById('Tokens').children.forEach(token => {
        let refs = token.getAttribute('ref').split(' ')
        caselet.departments.forEach(dpt => {
          if (refs[1] === dpt.code) {
            let caseletX = token.x.baseVal.value
            let caseletY = token.y.baseVal.value
            let tempPlayer = token.getBBox()
            tempPlayer = {
              x: caseletX,
              y: caseletY,
              width: tempPlayer.width,
              height: tempPlayer.height,
              cost: dpt.cost,
            }
            players.push(tempPlayer)
          }
        })
      })
      let temp = document.getElementById(caselet.tile).getBBox()
      let canResolve = false
      let cost = null
      let bounds = {
        left: temp.x,
        right: temp.x + temp.width,
        top: temp.y,
        bottom: temp.y + temp.height,
      }
      players.forEach(player => {
        let playerPos = {
          x: player.x + (player.width / 2),
          y: player.y + (player.height / 2),
        }
        if (playerPos.x < bounds.right && playerPos.x > bounds.left && playerPos.y > bounds.top && playerPos.y < bounds.bottom) {
          canResolve = true
          cost = player.cost
        }
      })

      if (canResolve) {
        let moves = null
        this.tokens.forEach(token => {
          if (token.id === this.selectedToken.id) {
            moves = token.actions.available
          }
        })
        if (moves >= cost) {
          this.tokens.forEach(token => {
            if (token.id === this.selectedToken.id) {
              token.actions.available -= cost
              this.modal('caselet was resolved in ' + caselet.tile)
              axios.post('/api/piece/moved', {
                params: {
                  start: caselet.tile,
                  end: caselet.tile,
                  pcs: localStorage.getItem('pcs'),
                  id: this.user.id,
                  token: this.selectedToken.id,
                  x: this.selectedToken.x.baseVal.value,
                  y: this.selectedToken.y.baseVal.value,
                  moves: cost,
                },
              })
            }
          })
          caselet.resolved = true
          this.highlightTile([caselet.tile, false])
          let change = true
          this.caselets.forEach(csl => {
            if (caselet.tile === csl.tile && csl.resolved === false) {
              change = false
            }
          })
          if (change) {
            document.getElementById(caselet.tile).setAttribute('stroke', '#6C757D')
            document.getElementById(caselet.tile).setAttribute('stroke-width', '1')
          }
          Object.keys(caselet.score).forEach(category => {
            this.scores[category] += caselet.score[category]
          })
          axios.post('/api/caselet/updated', {
            params: {
              pcs: localStorage.getItem('pcs'),
              id: this.user.id,
              token: caselet.id,
              caselet: caselet,
              action: 'resolve',
            },
          })
          this.saveGameboard()
        } else {
          this.modal('You do not have enough moves to resolve this disaster. Wait till next round to resolve')
        }
      } else {
        this.modal('You do not have the correct token on site of this incident')
      }
    },

    /* caseletInfo(event) {
      this.caselets.forEach(caselet => {
        if (caselet.id === event.target.parentNode.id && !this.dragging) {
          let html = '<p style="margin: 0; width: 50%; display: inline-block"><b>' + caselet.category + '</b></p>' +
            '<p  style="margin: 0; width: 50%; display: inline-block""><b>Info</b>: ' + caselet.detail + '</pid>' +
            '<p style="margin: 0;"><b>Required Departments</b>:<br><ul>'

          caselet.departments.forEach(temp => {
            html += '<li>' + temp.name + ': ' + temp.cost + ' actions required'
          })

          html += '</ul></p>'

          document.getElementById('caseletInfo').innerHTML = html
        }
      })
    }, */

    /* hideCaseletInfo() {
      document.getElementById('caseletInfo').innerText = ''
    }, */

    highlightTile(data) {
      let tile = data[0]
      let show = data[1]
      if (show) {
        document.getElementById(tile).setAttribute('stroke', 'red')
        document.getElementById(tile).setAttribute('stroke-opacity', '1')
        document.getElementById(tile).setAttribute('stroke-width', '.25%')
      } else {
        document.getElementById(tile).setAttribute('stroke', '#6C757D')
        document.getElementById(tile).setAttribute('stroke-opacity', '.52')
        document.getElementById(tile).setAttribute('stroke-width', '1')
      }
    },

    notify(event) {
      // this.caselets[event.index].notified = true
      let msg = 'Notification has been pushed to: '
      event.users.forEach(usr => {
        let data = usr.split('-')
        msg += data[1] + ', '
        let found = false
        this.caselets[event.index].hidden.forEach(temp => {
          if (temp === data[0]) {
            found = true
          }
        })
        if (!found) {
          this.caselets[event.index].hidden.push(usr)
        }
      })
      msg = msg.substring(0, msg.length - 2)
      this.modal(msg)
      axios.post('/api/caselet/updated', {
        params: {
          pcs: localStorage.getItem('pcs'),
          id: this.user.id,
          token: this.caselets[event.index].id,
          caselet: this.caselets[event.index],
        },
      })
      this.saveGameboard()
    },

    // Opens the invalid move modal
    modal(text) {
      this.text = text
      this.$bvModal.show('move-error')
      setTimeout(() => {
        this.$bvModal.hide('move-error')
      }, 1000)
    },

    /* *************************************   Websocket Functions   ************************************* */
    tokenMoved(id, tile) {
      console.log(this.start, tile)
      this.centerToken(document.getElementById(id), tile)
      this.saveGameboard()
    },

    caseletUpdate() {
      console.log('update', this.caselets)
    },

    clearOverlay() {
      this.overlaySelect = null
    },

    analyze(data) {
      this.tokens.forEach(token => {
        if (token.type === 'analysis') {
          token.actions.available -= data.cost
        }
      })
      axios.post('/api/piece/moved', {
        params: {
          start: 'analysis',
          end: 'analysis',
          pcs: localStorage.getItem('pcs'),
          id: this.user.id,
          token: 'analysis',
          x: 'analysis',
          y: 'analysis',
          moves: data.cost,
        },
      }).then(response => {
        this.saveGameboard()
      })
      this.analyzedCaselets.push(data.type)
    },

    highlightOverlay() {
      let grid = document.getElementById('grid-layer').children
      grid.forEach(tile => {
        tile.setAttribute('fill', 'none')
      })
      if (this.overlaySelect !== null) {
        Object.keys(this.forecast).forEach(tile => {
          this.forecast[tile].forEach(caselet => {
            if (caselet.name === this.overlaySelect) {
              if (caselet.percentage === 'Medium') {
                document.getElementById(tile).setAttribute('fill', 'orange')
                document.getElementById(tile).setAttribute('fill-opacity', '.5')
              } else if (caselet.percentage === 'High') {
                document.getElementById(tile).setAttribute('fill', 'red')
                document.getElementById(tile).setAttribute('fill-opacity', '.5')
              }
            }
          })
        })
      }
    },
  },

  watch: {
    overlaySelect: function() {
      this.highlightOverlay()
    },
    markers: function() {
      if (document.getElementById('Caselets')) {
        this.eventListeners()
      }
    },
  },
}
</script>

<style scoped lang="scss">
  .content {
    height: 100%;
  }

  .draggable {
    cursor: move;
  }

  #moves {
    position:fixed;
    width: 100%;
    div {
      margin: auto;
      width: fit-content;
      background-color: darkgrey;
    }
  }

  #notifications {
    position: absolute;
    bottom: 0;
    top: 0;
    left: 70%;
    right: 0;
    padding: 10px;
    .notification-pane{
      max-height: 50%;
    }
    #chat {
      height: 50%;
      min-height: 45%;
      overflow-y: auto;
    }
  }

  #mainGameboard {
    position: absolute;
    top: 25%;
    left: 50px;
    right: 30%;
    height: 70%;
    overflow: auto;
    padding: 5px 0 15px 0;
    #gameboardsvg {
      height: inherit;
      overflow-y: auto;
      min-height: 100%;
      display: inline;
    }
    #dataAnalysis{
      display: inline;
      position: absolute;
      left: 10px;
      bottom: 0;
    }
  }

  #caseletInfo {
    position: absolute;
    top: 10px;
    left: 10px;
    background-color: white;
    border: solid black 1px;
    #title {
      width:50%;
      display: inline-block;
    }
    p{
      margin: 0;
    }
  }

  #gameInfo {
    position: absolute;
    right: 30%;
    top: 0;
    bottom: 70%;
    left: 50px;
    padding: 10px 10px 0 10px;
    overflow: auto;
    #scores{
      display: inline-block;
      height: 100%;
      width: 49%;
      p{
        width: 50%;
        display: inline-block;
      }
    }

    #assets {
      display: inline-block;
      height: 100%;
      width: 50%;
      vertical-align: top;
      h1{
        margin: 0 0 10px 0;
      }
      table{
        tbody {
          display: block;
          height: fit-content;
          max-height: 125px;
          overflow: auto;
        }
        thead, tbody tr {
          display: table;
          width: 100%;
          table-layout: fixed;/* even columns width , fix width of table too*/
        }
        thead {
          width: calc( 100% - 1em )/* scrollbar is average 1em/16px width, remove it from thead width */
        }
        .assetToken {
          width: 40px;
        }
      }
    }
  }
  .modalToken {
    width: 40px;
  }
  h1 {
    #info {
      font-size: 15px;
      vertical-align: super;
    }
  }
</style>
